import{supabaseClient}from'../net/supabase-client.js?v=20260801-token-hash-1';

export async function loadGameSave(userId){
  const{data,error}=await supabaseClient
    .from('player_saves')
    .select('state,updated_at')
    .eq('user_id',userId)
    .maybeSingle();
  if(error)throw error;
  return data||null;
}

export async function writeGameSave(userId,state){
  const{data,error}=await supabaseClient
    .from('player_saves')
    .upsert({user_id:userId,state,updated_at:new Date().toISOString()},{onConflict:'user_id'})
    .select('updated_at')
    .single();
  if(error)throw error;
  return data;
}
